(function(rum) {
    // Вместе с ошибкой передается ее идетнификатор в этом списке, чтобы можно было ее распознать
    var filters = {
        url: {
            // Ошибки API расширений браузеров.
            '0': /(miscellaneous|extension)_bindings/,

            // Ошибки из внутренних элементов браузера Chrome.
            '1': /^chrome:/,

            // Ошибки из расширения Kaspersky Protection.
            '2': /kaspersky-labs\.com\//,

            // Ошибки из расширений браузеров
            '3': /^(?:moz|chrome|safari)-extension:\/\//,

            // Ошибки из пользовательских файлов.
            '4': /^file:/,

            // Ошибки в подгружаемых ресурсах (типа дополнительных скриптов расширений или Java-апплетов в Firefox)
            '5': /^resource:\/\//,

            // Ошибки в сеошном расширении https://nda.ya.ru/3UVNQe
            '6': /webnetc\.top/,

            // Ошибки AdGuard
            '7': /local\.adguard\.com/
        },
        message: {
            // Ошибки AdGuard.
            '0': /__adgRemoveDirect/,

            // Ошибки в CSP.
            '1': /Content Security Policy/,

            // Ошибки vid_mate_check is not defined
            '2': /vid_mate_check/,

            // Ошибки UC Browser.
            '3': /ucapi/,

            // Ошибки при обращении к элементам айфреймов в IE
            '4': /Access is denied/i,

            // Ошибки при обращении к элементам айфреймов
            '5': /^Uncaught SecurityError/i,

            // Ошибки Can't find variable: __ybro
            '6': /__ybro/,

            // Ошибки ReferenceError: __show__deepen is not defined
            '7': /__show__deepen/,

            // ntp is not defined
            '8': /ntp is not defined/,

            // Cannot set property 'install' of undefined
            '9': /Cannot set property 'install' of undefined/,

            // Внутренние ошибки файерфокса
            '10': /NS_ERROR/,

            // Ошибка загрузки скриптов по какой-либо причине (сетевые проблемы?)
            '11': /Error loading script/,

            // TypeError: undefined is not a function
            '12': /^TypeError: undefined is not a function$/,

            // https://st.yandex-team.ru/SERP-78992
            // ошибка Firefox/iOS 8,9,10 https://bugzilla.mozilla.org/show_bug.cgi?id=1394296
            '13': /__firefox__\.(?:favicons|metadata|reader|searchQueryForField|searchLoginField)/
        },
        stack: {
            // Ошибки из расширений браузеров
            '0': /(?:moz|chrome|safari)-extension:\/\//,
            // ошибки AdGuard в тех браузерах, которые показывают файлы расширений в стеке
            '1': /adguard.*\.user\.js/i
        }
    };

    /**
     * Проверяет, что ошибка из внешнего источника.
     *
     * @param {string} url
     * @param {string} message
     * @param {string} stack
     * @returns {Boolean}
     */
    function isExternalError(url, message, stack) {
        var customFilters = rum._errorSettings.filters || {};

        var currErrorPlaces = {
            url: (url || '') + '',
            message: (message || '') + '',
            stack: (stack || '') + ''
        };

        var commonFiltersStrs = collectExternalErrorInner(currErrorPlaces, filters);
        var customFiltersStrs = collectExternalErrorInner(currErrorPlaces, customFilters);

        return {
            common: commonFiltersStrs,
            custom: customFiltersStrs,
            hasExternal: !!(commonFiltersStrs || customFiltersStrs)
        };
    }

    /**
     * Проверяет, сматчилась ли ошибка и дополняет результат
     *
     * @param {string} str
     * @param {Object} errorItems
     * @return {String} result
     */
    function checkExternalErrorInner(str, errorItems) {
        if (!str || !errorItems) {
            return;
        }

        var result = [];

        for (var errorId in errorItems) {
            if (errorItems.hasOwnProperty(errorId)) {
                var regexp = errorItems[errorId];
                if (typeof regexp === 'string') {
                    regexp = new RegExp(regexp);
                }

                if (regexp instanceof RegExp && regexp.test(str)) {
                    result.push(errorId);
                }
            }
        }

        return result.join('_');
    }

    /**
     * Собирает информацию об ошибках
     *
     * @param {Object} currErrorPlaces
     * @param {Object} errorItems
     * @return {String} filtersStrs
     */
    function collectExternalErrorInner(currErrorPlaces, errorItems) {
        var filtersStrs = [];
        var strs;

        for (var errorPlace in filters) {
            if (filters.hasOwnProperty(errorPlace)) {
                strs = checkExternalErrorInner(currErrorPlaces[errorPlace], errorItems[errorPlace]);

                if (strs) {
                    filtersStrs.push(errorPlace + '~' +  strs);
                }
            }
        }

        return filtersStrs.join(';');
    }

    rum._isExternalError = isExternalError;
})(Ya.Rum);
